import React from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '@/lib/utils';
import { Badge } from '@/components/ui/badge';
import { FLAGS, dueState, splitTags } from '../../../common/models/crm.model';

/** Body of a board card: company line, then whatever the caller adds, then next action and tags. */
export const CrmCardBody: React.FC<{
  country?: string;
  title: string;
  children?: React.ReactNode;
  next?: string;
  due?: string;
  tags?: string;
}> = ({ country, title, children, next, due, tags }) => {
  const { i18n } = useTranslation();
  const state = dueState(due);
  const dueTxt = due ? new Date(`${due}T00:00`).toLocaleDateString(i18n.language || 'en', { day: 'numeric', month: 'short' }) : '';
  return (
    <>
      <p className="truncate text-sm font-medium">
        <span className="me-1">{(country && FLAGS[country]) || '🌐'}</span>{title}
      </p>
      {children}
      {next && (
        <p
          className={cn(
            'mt-1.5 line-clamp-3 text-xs',
            state === 'overdue' ? 'text-destructive' : state === 'today' ? 'text-warning' : 'text-muted-foreground',
          )}
        >
          {dueTxt && <span className="font-medium">{dueTxt} · </span>}{next}
        </p>
      )}
      {splitTags(tags).length > 0 && (
        <div className="mt-2 flex flex-wrap gap-1">
          {splitTags(tags).map((t) => <Badge key={t} variant="secondary" className="px-1.5 text-[10px]">{t}</Badge>)}
        </div>
      )}
    </>
  );
};
